import styles from './index.module.css'
import React from 'react'
import { connect } from 'react-redux'
import { updatePricingForm } from '@disco/state-management/actions/FormActions'
import type { PricingFormState } from '@disco/state-management/reducers/forms/pricing'
import { Flex } from 'components/ds'
import Lozenge from 'components/ui/lozenge'
import SwitchButtonGroup from 'components/ui/segmented-control'

const mapStateToProps = state => {
  return {
    pricingForm: state.forms.pricingForm,
  }
}

const mapDispatchToProps = {
  updatePricingForm,
}
type Props = {
  pricingForm: PricingFormState
  updatePricingForm: typeof updatePricingForm
}
export type PaymentPeriod = 'annual' | 'monthly'

/**
 * Billing period toggle switch component for pricing forms
 * Allows users to switch between annual and monthly billing with savings indicator
 */
const BillingPeriodSwitch = (props: Props): React.ReactNode => {
  const { pricingForm, updatePricingForm } = props

  const onPeriodSelect = (paymentPeriod: PaymentPeriod) => {
    updatePricingForm({
      paymentPeriod,
    })
  }

  return (
    <Flex align="center" gap="2">
      <Lozenge large color="blue" text="Save 10%" />
      <div className={styles.BillingPeriodSwitch_ButtonGroup}>
        <SwitchButtonGroup
          onChange={() =>
            onPeriodSelect(
              pricingForm.paymentPeriod === 'annual' ? 'monthly' : 'annual',
            )
          }
          value={pricingForm.paymentPeriod === 'annual'}
          labelLeft="annual"
          labelRight="monthly"
          size="1"
        />
      </div>
    </Flex>
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BillingPeriodSwitch) as any
